import moment from "moment";
import React, { useEffect, useRef, useState } from "react";

import "react-accessible-accordion/dist/fancy-example.css";
import ReactDatePicker from "react-datepicker";

function useOuterClick(callback) {
  const innerRef = useRef();
  const callbackRef = useRef();

  // set current callback in ref, before second useEffect uses it
  useEffect(() => {
    // useEffect wrapper to be safe for concurrent mode
    callbackRef.current = callback;
  });

  useEffect(() => {
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);

    // read most recent callback and innerRef dom node from refs
    function handleClick(e) {
      if (
        innerRef.current &&
        callbackRef.current &&
        !innerRef.current.contains(e.target)
      ) {
        callbackRef.current(e);
      }
    }
  }, []); // no need for callback + innerRef dep

  return innerRef; // return ref; client can omit `useRef`
}

function CustomFilterOptions(props) {
  const currentYear = new Date().getFullYear();
  const [startDate, setStartDate] = useState(new Date(currentYear, 0, 1));
  const [endDate, setEndDate] = useState(new Date());
  const innerRef = useOuterClick((e) => {
    if (
      e.target.id != "customeFilter" &&
      e.target?.classList[0] != "react-datepicker__month-text"
    ) {
      props.setChannelPopover(false);
    }
  });

  useEffect(() => {
    if (
      props?.customFilter !== null &&
      props?.customFilter?.startDate &&
      props?.customFilter?.endDate
    ) {
      setStartDate(new Date(props?.customFilter?.startDate));
      setEndDate(new Date(props?.customFilter?.endDate));
    }
  }, [props?.customFilter]);

  function handlefilterResource(e) {
    let res = {};
    res.startDate = moment(startDate).format("YYYY-MM");
    res.endDate = moment(endDate).format("YYYY-MM");
    props.handleCustomFilterOption(res);
    props.setChannelPopover(false);
  }

  function handleResetfilterResource(e) {
    let res = {};
    setStartDate(new Date(currentYear, 0, 1));
    setEndDate(new Date());
    props.handleCustomFilterOption(res);
    props.setChannelPopover(false);
  }

  return (
    <div className="hideCustomFilter" id="customFilterOptions" ref={innerRef}>
      <div className="d-flex input-flex-part">
        <div className="form-group">
          <label>Start Date</label>
          <ReactDatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            dateFormat="MM-yyyy"
            showMonthYearPicker
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label>End Date</label>
          <ReactDatePicker
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            dateFormat="MM-yyyy"
            showMonthYearPicker
            className="form-control"
          />
        </div>
      </div>
      <div className="d-flex filter-flex">
        <button
          className="btn d-block my-2 them-button"
          type={"button"}
          onClick={(e) => handlefilterResource(e)}
        >
          Apply
        </button>
      </div>
    </div>
  );
}

export default CustomFilterOptions;
